import React, { useEffect, useState } from 'react';
import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import socketService from '../Services/SocketService';

const AppInitializer = ({ children }) => {
  const { t } = useTranslation();
  const [isInitialized, setIsInitialized] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const initializeApp = async () => {
      try {

        
        // Initialize socket service
        await socketService.getSocketBaseUrl();
        

        setIsInitialized(true);
      } catch (error) {

        setError(error);
        // Still set as initialized to not block the app
        setIsInitialized(true);
      }
    };

    initializeApp();
  }, []);

  if (!isInitialized) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column'
      }}>
        <Spin size="large" />
        <div style={{ marginTop: 16 }}>
          {t('common.initializingRealtimeConnections')}
        </div>
      </div>
    );
  }

  if (error) {

  }

  return children;
};

export default AppInitializer; 